import request from "@/utils/request";
export default {
    // 获取farm列表
    getSelectorForFram: (param) => {
        return request({
            url: `/rmc/produce/medicine/getSelectorForFram`,
            method: "post",
        });
    },
    // 获取farmGroup列表
    getFarmGroup: (farmName) => {
        return request({
            url: `/rmc/produce/medicine/getFarmGroupByFarm/${farmName}`,
            method: "post",
        });
    },
    // 获取下拉框列表
    getSelector: (param) => {
        return request({
            url: `/rmc/produce/medicine/getSelector`,
            method: "post",
        });
    },
    // 分页查询药品清单列表
    getMedicineList: (param) => {
        return request({
            url: `/rmc/produce/medicine/queryPage`,
            method: "post",
            data: param,
        });
    },
    // 保存
    saveMedicine: (param) => {
        return request({
            url: `/rmc/produce/medicine/save`,
            method: "post",
            data: param,
        });
    },
    // 提交
    submitMedicine: (param) => {
        return request({
            url: `/rmc/produce/medicine/submit`,
            method: "post",
            data: param,
        });
    },
    // 导出
    exportMedicine: (param) => {
        return request({
            url: `/rmc/produce/medicine/export`,
            method: "post",
            data: param,
            responseType: "blob",
            fullResponse: true,
        });
    },
    // 删除
    deleteMedicine: (param) => {
        return request({
            url: `/rmc/produce/medicine/delete`,
            method: "post",
            data: param,
        });
    },
    // 药品清单详情
    queryDetail: (param) => {
        return request({
            url: `/rmc/produce/medicine/queryDetail/${param}`,
            method: "post",
            data: param,
        });
    },
    // 确认无更新
    approveAndNotUpdate: (param) => {
        return request({
            url: `/rmc/produce/medicine/approveAndNotUpdate`,
            method: "post",
            data: param,
        });
    },
    // 查询历史记录
    queryHistory: (param) => {
        return request({
            url: `/rmc/produce/medicine/queryHistory`,
            method: "post",
            data: param,
        });
    },
    // 更新日志
    queryPageForUpdateLog: (param) => {
        return request({
            url: `/rmc/produce/medicine//queryPageForUpdateLog`,
            method: 'post',
            data: param
        });
    },
    // 季度报表导出
    exportSnapshot: (param) => {
        return request({
            url: `/rmc/produce/medicine/exportSnapshot`,
            method: 'post',
            data: param,
            responseType: "blob",
            fullResponse: true,
        });
    },
    // 根据有效成分获取用途分类
    getSelectorForEffective: (param) => {
        return request({
            url: `/rmc/produce/medicine/getSelectorForEffective`,
            method: 'post',
            data: param,
        });
    },
    // 导入模板
    importExcelForProduceMedicineTemp: (param) => {
        return request({
            url: `/rmc/produce/medicine/importExcelForProduceMedicineTemp`,
            method: 'get',
            data: param,
            responseType: "blob",
            fullResponse: true,
        });
    },
    // 商品名
    getProductNames: (name) => {
        return request({
            url: `/rmc/produce/medicine/getProductNames`,
            method: 'post',
            data: name
        });
    },
    // 获取状态列表
    getStatusList: (param) => {
        return request({
            url: `/inputChoice/queryAutoloadInputChoice`,
            method: "post",
            data: param,
        });
    },

    // 更新日志导出
    downloadUpdateLogList: (param) => {
        return request({
            url: `/rmc/produce/medicine/downloadUpdateLogList`,
            method: 'post',
            data: param,
            responseType: "blob",
            fullResponse: true,
        });
    },

};